"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useReorder = void 0;
var _react = require("react");
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var EMPTY_ARRAY = [];
var useReorder = exports.useReorder = function useReorder(_ref) {
  var onReorder = _ref.onReorder,
    _ref$order = _ref.order,
    order = _ref$order === void 0 ? EMPTY_ARRAY : _ref$order;
  var onReorderRef = (0, _react.useRef)();
  onReorderRef.current = onReorder;
  return (0, _react.useCallback)(function (params, e, details) {
    var targetIndexWIthOutOffset = params.targetIndex,
      oldIndexWIthOutOffset = params.oldIndex;
    var api = details.api;
    var targetAllColumnsOrder = api.getAllColumns().map(function (_ref2) {
      var field = _ref2.field;
      return field;
    });
    var oldAllColumnsOrder = moveInArray(targetAllColumnsOrder, targetIndexWIthOutOffset, oldIndexWIthOutOffset);
    var targetField = oldAllColumnsOrder[targetIndexWIthOutOffset];
    var oldField = oldAllColumnsOrder[oldIndexWIthOutOffset];
    var oldIndex = order.indexOf(oldField);
    var targetIndex = order.indexOf(targetField);
    var newOrder = moveInArray(order, oldIndex, targetIndex);
    onReorderRef.current(newOrder);
  }, [order.toString()]);
};
function moveInArray(arr, from, to) {
  var arrClone = _toConsumableArray(arr);
  // Delete the item from it's current position
  var item = arrClone.splice(from, 1);
  // Move the item to its new position
  arrClone.splice(to, 0, item[0]);
  return arrClone;
}